<div class="content-block">
    <div class="row">
      <div class="col-md-6">
        <h2 class="content-block">Nuovo articoli</h2>
      </div>
      <div class="col-md-6">
        <span class="float-end">
        
        
        </span>
      </div>
    </div>
  </div>
  

<div class="content-block">
    <div class="row">
  
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="nav-tabs-custom">
              <ul class="nav nav-pills">
                 <li class="nav-item"><a class="nav-link active" href="#datiarticolo" data-bs-toggle="tab">Dati articolo</a></li>                
              </ul>
            </div>
         
            <div class="tab-content">
  
                <div class="tab-pane active" id="datiarticolo" >
                    <app-form-articolo [articolo]="articolo" [isNew]="true"></app-form-articolo>                
                </div> <!-- /.tab-pane -->
            </div>
          </div>
        </div>
  
      </div>
  
    </div>
</div>

